import { api } from '~/trpc-extra/api';
import { useRouter } from 'next/router';
import { queryParamToString } from '~/logic/query-param';
import type { TestListItem } from '~/server/api/routers/test';
import { notifications } from '@mantine/notifications';
import { ItemCombobox } from '~/components/common/ItemCombobox';
import { TestTag } from '~/components/test/TestTag';
import { useManageTagsDialog } from '~/hooks/tag/useManageTagsDialog';
import type { RouterOutputs } from '~/trpc-extra/api';

export function TestTagCombobox({ test, tags }: { test: TestListItem; tags: RouterOutputs['tag']['list'] }) {
  const router = useRouter();
  const projectId = queryParamToString(router.query.projectId);

  const trpcUtils = api.useUtils();
  const openManageTagsDialog = useManageTagsDialog();

  const { mutate: updateTags } = api.test.updateTest.useMutation({
    onError: () => {
      notifications.show({
        title: 'Error',
        message: 'Error updating tags',
        color: 'red',
      });
    },
    onSettled: async () => {
      await trpcUtils.test.listTests.invalidate({ projectId });
    },
  });

  return (
    <ItemCombobox
      items={tags}
      selectedItems={test.tags}
      onItemsChange={(newTagIds) =>
        updateTags({
          testId: test.id,
          testData: {
            tags: newTagIds,
          },
        })
      }
      onManageItems={openManageTagsDialog}
      itemName="tag"
      renderItem={(tag, selected) => (
        <TestTag
          label={tag.name}
          selected={selected}
          disabled
        />
      )}
    />
  );
}
